import * as Sentry from "@sentry/react";

export const ERROR_TYPES = {
	UnexpectedSessionIdException: "UnexpectedSessionIdException"
};

export function logError(message = "", extra = {}) {
	if (process.env.ENV === "dev")
		return console.log(message, extra); // eslint-disable-line no-console
	Sentry.captureEvent({ message, extra });
}